import React from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import Popup from "react-popup";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useEffect } from "react";
import ReimpresionRuedaService from "../../../services/consultas/ReimpresionRuedaService";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export const RuedasComprobante = () => {

  const [state, setState] = useState({
    listaRueda: [],
    listaPeriodo: [],
    periodoElegido: null,
  })

  const notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  useEffect(() => {
    obtenerPeriodo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });

    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();

    var mesChar = "";
    for (var i = 0; i < 12; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "/" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    setState({ ...state, listaPeriodo: lista });
    return lista;
  };

  const handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
      setState({
        ...state,
        listaRueda: [],
        periodoElegido: null,
      });
    else {
      setState({
        ...state,
        periodoElegido: selectedOption.value,
      });
    }
  };

  const getColumn = () => {
    return [
      {
        name: "Fecha",
        selector: row => row.fechaTrans,
        // width: "100px",
      },
      {
        name: "Hora",
        selector: row => row.horaTrans,
        // width: "100px",
      },
      {
        name: "Cuenta Débito",
        selector: row => row.cuentaDebito,
        // width: "180px",
      },
      {
        name: "Concepto",
        selector: row => row.concepto,
        // width: "130px",
      },
      {
        name: "Cuenta Crédito",
        selector: row => row.cuentaCredito,
        // width: "180px",
      },
      {
        name: "Importe",
        selector: row => row.importe,
        // width: "150px",
        right: true,
      },
      {
        cell: (row) => (
          <div>
            <button
              id={row.id}
              key={row.id}
              className="btn btn-xs btn-outline-success"
              value={row.id}
              target="_blank"
              onClick={() => descargar(row)}>
              {" "}
              <i className="fa fa-download" /> <b>Descargar</b>
            </button>
          </div>
        ),
      },
    ];
  }

  const obtenerlistaRueda = async () => {

    if (state.periodoElegido !== null) {
      var mesAnho = state.periodoElegido;
      await trackPromise(
        ReimpresionRuedaService.reimprimirLista(mesAnho)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);

            if (jsonData.codigo === "0") {

              let lista = jsonData.detalleResultados;

              if (lista.length === 0) {
                Popup.queue(notifiPopup("Info", "No existen registros en el mes seleccionado"));
                return;
              }

              lista = lista.map(element => ({
                ...element,
                importe: `${formatoSeparadorMilesValue(element.importe)} ${element.moneda}.`
              }));

              setState({ ...state, listaRueda: lista });

            } else {
              Popup.queue(notifiPopup("Info", jsonData.mensaje));
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    }

  };


  ////// DESCARGA /////

  const descargar = (row) => {

    let split = row.concepto.split("OPER=");
    let nroOperacion = split[1];

    const data = {
      titulo: "Transferencia entre Cuentas",
      moneda: row.moneda,
      nroOperacion,
      cuentaCredito: row.cuentaCredito,
      titularCuenta: authService.getSocio().nombreCompleto,
      fechaOperacion: `${row.fechaTrans} ${row.horaTrans}`,
      importeCredito: row.importe
    }

    trackPromise(
      ReimpresionRuedaService.descargarComprobante(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };


  const ListaRueda = ({ columns, data }) => {

    return (
      data.length > 0 &&
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={columns}
                      data={data}
                      dense={true}
                      striped={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                      expandableRowss
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  //var periodo = state.listaPeriodo;
  //if (state.listaPeriodo.length === 0) periodo = state.listaPeriodo;

  return (
    <div className="content-wrapper">
      <Titulo texto="Pago de Ruedas" />
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="col-md-12" style={{ zIndex: 1 }}>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="input-label-bold">Mes *</label>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <Select
                          required="true"
                          placeholder="-- Seleccione --"
                          onChange={handleChangeSelector}
                          options={state.listaPeriodo}
                          isClearable
                          noOptionsMessage={() => "SIN DATOS"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <button
                        className="btn btn-cu-primary"
                        onClick={obtenerlistaRueda}
                      >
                        <FontAwesomeIcon icon={faCheck} />  Consultar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ListaRueda columns={getColumn()} data={state.listaRueda} />
        </div>
      </section>
    </div>
  );

}

